<template>
  <div>
    <div id="chart-container" class="by-value">
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="cp-by-emotional-value-e-chart" class="chart-row">
        <profile-chart-header
          :title="'Driver Profile | ' + titleSuffix"
          :display="this.$parent.getDisplayView() && getDisplayView()"
          :content-list="contentList"
          :display-download-comments="true"
          :content-name="'Driver Profile'"
          :input-display-number-of-responses="displayNumberOfResponses"
          :input-show-tooltip="showTooltip"
          @set-display-number-of-responses="setDisplayNumberOfResponsesForValueComponents"
          @set-show-tooltip="setShowTooltipForValueComponents"
        />   
        <profile-chart ref="eChartValueDriver"
              :e-chart-mini-id="'profile-value-driver-chart-mini'"
              :e-chart-id="'profile-value-driver-chart'"
              :input-report-type-name="'Chart - Value Drivers'"
              :modal-id="'value-drivers-chart'"
              :is-saved-card="$parent.clientChart.clientChartId != 0" 
              :input-client-chart="this.$parent.clientChart"
              :inputDownloadFileName="'Emotional Drivers - ' + titleSuffix"
              @save-table="saveProfileDataTable"
              @save-criteria="buildClientChart"/>        
      </div>
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="cp-by-functional-value-e-chart" class="chart-row">
        <profile-chart ref="eChartValueComponents"
            :e-chart-mini-id="'profile-value-chart-mini'"
            :e-chart-id="'profile-value-chart'"
            :input-report-type-name="'Chart - Value Components'"
            :modal-id="'value-components-chart'"
            :is-saved-card="$parent.clientChart.clientChartId != 0" 
            :input-client-chart="this.$parent.clientChart"
            :inputDownloadFileName="'Functional Drivers - ' + titleSuffix"
            @save-table="saveProfileDataTable"
            @save-criteria="buildClientChart"/>        
      </div>
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="valueFunctionalTable.tableContainerId" :class="isInsiderUser ? 'chart-data hide-table-data' : 'chart-data'">
        <div v-show="isInsiderUser" class="overlay">
            <img class="overlay-inner" v-show="isInsiderUser" src="../../../assets/img/overlap.png" style="width: 490px"/>
        </div>
        <chart-data-table
          ref="functionalDataTable"
          v-show="this.$parent.getDisplayView() && getDisplayView()"
          :chart-data="this.valueFunctionalTable.data"
          :display-direction="'vertical'"
          :is-saved-card="$parent.clientChart.clientChartId != 0" 
          :data-container-id="valueFunctionalTable.tableContainerId"
          :container-id="'value_functional_needs_chart'"
          :column-defs="this.chart.columnDefsFunctional"
          :table-class="'table display responsive row-border table-hover'"
          :table-width="'auto'"
          :content-list="this.contentList"
          :table-title="this.valueFunctionalTable.title"
          :report-page-type-name="'Table - Value Components'"
          :insight-modal-id="'value-components-table'"
          :inputDownloadFileName="'Driver Profile - ' + titleSuffix"
          :effort-list="functionalEffortList"
          :use-alternate-title="true"
          :display-profile-strength-legend="$parent.displayProfileStrengthLegend"
          @display-initiatives="$parent.displayInitiativesForProfileTable"
          @go-to-explore="$parent.goToExploreForProfileTable"
        ></chart-data-table>
      </div>
    </div>
    <insights
      ref="insightsFunctionalChart"
      :modal-name="'value-components-chart'"
      :report-page-type-name="'Chart - Value Components'"
      :entry-page-content="this.pageContentForReport"
      :page-content="this.pageContent"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsFunctionalTable"
      :modal-name="'value-components-table'"
      :report-page-type-name="'Table - Value Components'"
      :entry-page-content="this.pageContentForReport"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsEmotionalChart"
      :modal-name="'value-drivers-chart'"
      :report-page-type-name="'Chart - Value Drivers'"
      :entry-page-content="this.pageContentForReport"
      @saveAllReportPages="saveAllReportPages"
      @saveReportPage="$parent.updateReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ProfileChart from "../../../views/echarts/ProfileChart.vue";
import ProfileChartHeader from "../../../components/echarts/ProfileChartHeader.vue";
import ProfileService from "../../../services/echarts/profile.service";

import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import NeedsService from "../../../services/needs.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";

export default {
  name: "ByValue",
  mixins: [ChartCompanyMixins],
  components: {  ProfileChart, ProfileChartHeader},
  data() {
    return {
      displayType: "value",
      functionalEffortList: [],
      emotionalEffortList: [],
      showTooltip:true,
      displayNumberOfResponses: false,
      eChartDataForValueDriver: {},
      valueFunctionalTable: {
        id: "",
        data: {},
        tableContainerId: "value_functional_needs_data_container",
        title:
          ""
      },
      drivers: [
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        }
      ],
      titleSuffix: "",
    };
  },
  props: {
     verbatimsData: {
      type: Array,
      default: function() {
/*        
        return [
    {
        "name": "Positive Verbatims",
        "needType": "emotional",
        "needs": [
            "Creativity",
            "Assurance"
        ]
    },
    {
        "name": "Negative Verbatims",
        "needType": "functional",
        "needs": [
            "Pricing",
            "On-Time/In-Full Delivery",
            "Product Choice/Availability"
        ]
    }
];
*/        
        return [];
      }    
   },
    chartData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    contentList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    surveyCode: function() {
      return this.$parent.$data.survey.surveyCode;
    },    
  },
  mounted() {
    $.extend(this.$refs.functionalDataTable.configuration, { orderFixed: [[0, "asc"]] });
  },
  created() {},
  methods: {
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Value Components") {
        this.$refs.insightsFunctionalChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsFunctionalChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Value Components") {
        this.$refs.insightsFunctionalTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsFunctionalTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Chart - Value Drivers") {
        this.$refs.insightsEmotionalChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsEmotionalChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } 
    },
    async processChartData() {
      try {
        if (typeof this.eChartCriteria != "undefined" && typeof this.eChartCriteria.displayNumberOfResponses != "undefined") {
          this.displayNumberOfResponses = this.eChartCriteria.displayNumberOfResponses;
        }
        if (typeof this.eChartCriteria != "undefined" && typeof this.eChartCriteria.showTooltip != "undefined") {
          this.showTooltip = this.eChartCriteria.showTooltip;
        }
        this.chart = ChartService.getChartAttributes("Profile By Value");
        for (let i = 0; i < this.chartData.length; i++) {
          let needsData = JSON.parse(JSON.stringify(this.chartData[i]));
          let otherData = needsData["otherData"];
          let needsList = otherData["needsList"];
          let driverList = otherData["driverList"];
          let companyColorList = otherData["companyColorList"];
          this.$parent.selectedValueRoadMapId = otherData["selectedValueRoadMapId"];
          TableService.setCompanyColorList(companyColorList);
          let containerId = needsData["containerId"];
          this.table.id = containerId;
          if (containerId === "value_functional_needs_chart") {
            let titleSuffix = otherData["titleSuffix"];
            if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
              this.titleSuffix = titleSuffix;
            }
            needsData.rows = otherData["finalRows"];
            this.functionalEffortList = otherData["effortList"];
            let breakPointList = otherData["breakPointList"];
            ChartService.setVerticalLineBreakPoints(breakPointList);
            NeedsService.setFunctionalNeedsList(needsList);
            let experienceComponentsList = otherData["experienceComponentsList"];
            let labelIndex = 3;
            let copyOfChartData = JSON.parse(JSON.stringify(needsData));

            for (let indexRows = 0; indexRows < needsData.rows.length; indexRows++) {
              let copyOfChartDataRow = copyOfChartData.rows[indexRows].c;
              let originalName = copyOfChartDataRow[labelIndex].v;
              if (originalName != null && originalName.includes(",")) {
                let copyValue = copyOfChartDataRow[labelIndex].v.split(",");
                if (typeof copyValue != "undefined") {
                  copyOfChartDataRow[labelIndex].v.trim();
                  copyOfChartDataRow[labelIndex].v = copyValue[0] + " / " + copyValue[1];
                  NeedsService.replaceNeedName(originalName, copyOfChartDataRow[labelIndex].v, "emotional");
                  if (driverList.length > indexRows-1){
                    this.drivers[indexRows].emotionalNeedName1 = copyValue[1];
                    this.drivers[indexRows].emotionalNeedName2 = copyValue[0];
                    this.drivers[indexRows].experienceComponents = JSON.parse(JSON.stringify(experienceComponentsList[indexRows]));
                  }
                }
              }
            }
            for (let index = 0; index < driverList.length; index++) {
              this.drivers[index].name = driverList[index].name;
              this.drivers[index].importanceRank = driverList[index].importanceRank;
              this.drivers[index].intensityRank = driverList[index].intensityRank;
              this.drivers[index].dissonanceRank = driverList[index].dissonanceRank;
              let weight = driverList[index].weight;
              if (weight != null && !isNaN(weight)) {
                let finalWeight = weight * 100;
                this.drivers[index].weight = Number(finalWeight).toFixed(1) + "%";
              } else {
                this.drivers[index].weight = "--";
              }
              this.drivers[index].performanceAssessment = JSON.parse(JSON.stringify(driverList[index].performanceAssessment));
            }
            this.valueFunctionalTable.id = containerId;
            let columns = needsData["cols"];
            let isPositiveCorrelation = otherData["isPositiveCorrelation"];
            this.chart.columnDefsFunctional = this.buildColumns(columns,isPositiveCorrelation);

            this.valueFunctionalTable.data = JSON.parse(JSON.stringify(copyOfChartData));
            this.$parent.setChartResults(needsData.companyList);
            this.$parent.$data.criteriaResultsList = AdminService.removeByName(needsData.criteriaList, "Competitor");
            let showRelationshipStrength = this.$parent.$data.criteriaResultsList.find(item => item.name === "Show Relative Strength");
            if (typeof showRelationshipStrength != "undefined" && showRelationshipStrength.displayValue == "Yes") {
              this.$parent.displayProfileStrengthLegend = true;
            } else {
              this.$parent.displayProfileStrengthLegend = false;
            }
            // for AI Profile Recommendations
            this.setRecommendationsData(needsData, isPositiveCorrelation);
            
          } else if (containerId === "value_emotional_needs_chart") {
            this.emotionalEffortList = otherData["effortList"];
            this.functionalEffortList = this.functionalEffortList.concat(this.emotionalEffortList);

            NeedsService.setEmotionalNeedsList(needsList);
          }
        }
        this.$parent.needsList = NeedsService.getNeedsList();
        this.$parent.valueMapData.data = this.drivers;
        this.$parent.valueMapData.title = this.$parent.survey.name + " Value Map";
        this.$root.$emit("check-number-of-responses");          
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
        this.setEChartCriteria(this.$parent.$refs.chartCriteria.eChartCriteria);
        this.parseProfileDataForValue(JSON.parse(JSON.stringify(this.chartData)));
        this.eChartCriteria.eChartType = "stacked-bar-vertical";
        this.processVerbatimsData();
        this.$refs.eChartValueComponents.processChart(true,"value",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower);
        $("#cp-by-emotional-value-e-chart").addClass("chart-wrapper");
        $("#cp-by-functional-value-e-chart").addClass("chart-wrapper");

        this.parseProfileDataForValueDriver(JSON.parse(JSON.stringify(this.chartData)));
        let eChartCriteria = JSON.parse(JSON.stringify(this.eChartCriteria));
        eChartCriteria.eChartType = "bar-horizontal";
        this.eChartDataForValueDriver.verbatims = (JSON.parse(JSON.stringify(this.verbatimsData))); 
        this.$refs.eChartValueDriver.processChart(true,"value-driver",this.eChartDataForValueDriver,eChartCriteria,false);
      } catch (err) {
        ErrorService.processException("ByValue.displayChartCallback", err, "chart", this);
      }
    },
    processVerbatimsData: function(){
        if (!$.isEmptyObject(this.verbatimsData)) {      
          this.eChartCriteria.eChartType = "stacked-bar-vertical";
          this.eChartData.verbatims = (JSON.parse(JSON.stringify(this.verbatimsData))); 
          this.eChartDataForValueDriver.verbatims = (JSON.parse(JSON.stringify(this.verbatimsData))); 
          if (this.chartData.length != 0) {
            this.$refs.eChartValueComponents.processChart(true,"value",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower);
          }
          let eChartCriteria = JSON.parse(JSON.stringify(this.eChartCriteria));
          eChartCriteria.eChartType = "bar-horizontal";
          if (this.chartData.length != 0) {
            this.$refs.eChartValueDriver.processChart(true,"value-driver",this.eChartDataForValueDriver,eChartCriteria,false);
          }
        }
    },
    buildColumns(columns,isPositiveCorrelation = true){
      const EMPTY_CELL = "--";
      let returnColumns = [
          TableService.getOrderSequence(),
          { targets: [0], visible: false },
          {
            targets: [1],
            className: "dt-left",
            width: 50,
            type: 'non-empty-string',
            render(v) {
              if (v == null) {
                return " ";
              }
              if (v != null && !isNaN(v)) {
                if (v == 0) {
                  return EMPTY_CELL;
                }
                v = v * 100;
                return Number(v).toFixed(1) + "%";
              } else {
                return EMPTY_CELL;
              }
            }
          },
          {
            targets: [2],
            width: 150,
            className: "dt-left",
            render: function(data, type, row, meta) {
              return data;
            }
          },
          {
            targets: [3],
            className: "dt-left",
            width: 190,
            render: function(data, type, row, meta) {
              if (data == null) {
                return null;
              }
              var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
              let originalData = data;
              data = data.length > 40 ? data.substr(0, 40) + "…" : data;
              let displayData = data;
              let includeToolTip = data.length > 40;

              if (type === "display"  && originalData != "Emotional Average" && originalData != "Functional Average" && originalData != "Overall Average") {
                let isEmotional = NeedsService.isEmotionalNeedByDimensionName(data);
                let needType = isEmotional ? "emotional" : "functional";
                let fieldNumber = NeedsService.getNeedNumber(data, needType);
                if (fieldNumber == 0) {
                  fieldNumber = meta.row + 1;
                }
                let needName = "Functional Need " + fieldNumber;
                data =
                  '<div class="my_ellipse"><span class="popUpForRoadMapInitiatives"  data-modal-name="' +
                  needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/icons/wratings-mini-logo.png" class="icon-table-view"/></span>';
                data += ' <span class="popUpForExplorer"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/magnifying-glass-dollar.svg" class="icon-table-view"/></span>';

                if (includeToolTip) {
                  data += '<span data-toggle="tooltip" title="' + originalData + '">' + displayData + "</span>";
                } else {
                  data += displayData;
                }
                data += "</div>";
              }
              return data;
            }
          },
          TableService.getNumericTableAttribute([4], "dt-right", 50),
          TableService.getNumericTableAttribute([5], "dt-right", 50),
          TableService.getNumericTableAttribute([6], "dt-right ", 50)
        ];
        let position = 0;
        columns.forEach(function(column) {
          if (position >= 7){
            if (column.id == "pricing-power"){
              returnColumns.push(TableService.getPercentTableAttribute([position], "dt-right", 50, 2)); // Pricing Power
            } else if (column.id == "relative-strength"){
              returnColumns.push(TableService.getRelativeStrengthTableAttribute([position], "dt-right", 50, 2,isPositiveCorrelation)); // Relative Strength
            } else if (column.label == "Metric" || column.label == "Growth Ideas" || column.label == "Roadmap Initiatives") {
              returnColumns.push(TableService.getMetricTableAttribute([position], "dt-left", 200, 2));
            } else {
              returnColumns.push(TableService.getNumericTableAttribute([position], "dt-right", 50));
            }
          }
          position++;
        });
        return returnColumns;
    },
    setShowTooltipForValueComponents(inputShowTooltip){
      this.processVerbatimsData();
      this.eChartCriteria.showTooltip = inputShowTooltip;
      this.$parent.$refs.chartCriteria.eChartCriteria.showTooltip = inputShowTooltip;
      this.$refs.eChartValueComponents.processChart(this.getDisplayView(),"value",this.eChartData,this.eChartCriteria,this.displayPricingPower);
      this.showTooltip = inputShowTooltip;

      let eChartCriteria = JSON.parse(JSON.stringify(this.eChartCriteria));
      eChartCriteria.eChartType = "bar-horizontal";
      this.$refs.eChartValueDriver.processChart(this.getDisplayView(),"value-driver",this.eChartDataForValueDriver,eChartCriteria,false);
    },
    setDisplayNumberOfResponsesForValueComponents(inputDisplayNumberOfResponses){
      this.processVerbatimsData();
      this.eChartCriteria.displayNumberOfResponses = inputDisplayNumberOfResponses;
      this.$parent.$refs.chartCriteria.eChartCriteria.displayNumberOfResponses = inputDisplayNumberOfResponses;
      this.$refs.eChartValueComponents.processChart(this.getDisplayView(),"value",this.eChartData,this.eChartCriteria,this.displayPricingPower);
      this.displayNumberOfResponses = inputDisplayNumberOfResponses;

      let eChartCriteria = JSON.parse(JSON.stringify(this.eChartCriteria));
      eChartCriteria.eChartType = "bar-horizontal";
      this.$refs.eChartValueDriver.processChart(this.getDisplayView(),"value-driver",this.eChartDataForValueDriver,eChartCriteria,false);
    },
    parseProfileDataForValue: function(inputData){
      let itemsToRemove = {
          lastColumns: 0,
          firstColumns: 3,
          gapColumn: 1,
          lastRows: 1
        };
        let data = {};
        let chart1Data = inputData[0];
        data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
        data = ProfileService.parseLegendAndColorData(chart1Data,data);
        this.eChartData = JSON.parse(JSON.stringify(data));
    },    
    parseProfileDataForValueDriver: function(inputData){
      let itemsToRemove = {
          lastColumns: 0,
          firstColumns: 3,
          gapColumn: 1,
          lastRows: 1
        };
        let data = {};
        let chart1Data = inputData[1];
        data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
        data = ProfileService.parseLegendAndColorData(chart1Data,data);
        data = ProfileService.parseDriverListData(inputData[0],data);
        this.eChartDataForValueDriver = JSON.parse(JSON.stringify(data));
    },    
    async saveProfileDataTable() {
      let vm = this;
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        setTimeout(function() {
            ReportService.saveReportPage(vm.getReportTableContent("value_functional_needs_chart"), "Table - Value Components", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
            ReportService.saveReportPage(vm.getReportTableContent("value_emotional_needs_chart"), "Table - Value Drivers", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
            ReportService.saveReportTableFile(vm.$refs.functionalDataTable.getTableData(), "Table - Value Components", vm.$parent.clientChart, vm.saveReportTableFileCallback, vm);
        }, 1500);    
      }
    },    
    saveAllReportPages() {
      this.saveProfileDataTable();
    },
  },
  watch: {
    surveyCode: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.$refs.eChartValueComponents.clear();} catch(e){}
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.$refs.eChartValueDriver.clear();} catch(e){}
    },
    verbatimsData: function() {
      if (this.$parent.$refs.chartCriteria.$data.displayType == "value") {
        this.processVerbatimsData();
      } 
    },
    chartData: function() {
      if (this.$parent.$refs.chartCriteria.$data.displayType == "value") {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    },

    eChartCriteria: function() {
      if (typeof this.eChartCriteria != "undefined" && typeof this.eChartCriteria.displayNumberOfResponses != "undefined") {
          this.displayNumberOfResponses = this.eChartCriteria.displayNumberOfResponses;
      }
      if (typeof this.eChartCriteria != "undefined" && typeof this.eChartCriteria.showTooltip != "undefined") {
          this.showTooltip = this.eChartCriteria.showTooltip;
      }
    }
  }
};
</script>
